import { z } from "zod";

// As CINCO métricas do cenário aplicado, e a ordem em que se lê.
//
// Vivem em arquivo próprio (Spec 077) porque três contratos dependem delas — o compromisso, a
// classificação da divergência e a fila de trabalho — e um deles precisaria importar do outro para
// alcançá-las, o que fecharia um ciclo de módulos que o ESM resolve com `ReferenceError` de TDZ em
// tempo de import. A chave e a ordem não são de nenhum dos três: são do domínio.

export const AppliedScenarioMetricKeySchema = z.enum([
  "availability",
  "performance",
  "quality",
  "oee",
  "goodProduction",
]);
export type AppliedScenarioMetricKey = z.infer<typeof AppliedScenarioMetricKeySchema>;

/**
 * Ordem de exibição das métricas. Fixa: A × P × Q, o produto, e a entrega.
 *
 * Spec 076 — vive no contrato, e não no view da API, porque a APURAÇÃO (que a monta linha a linha)
 * saiu para `@opus-dt/closed-loop` e o view continuou na API. Duplicá-la faria a apuração gravar
 * numa ordem e a leitura exibir noutra no primeiro dia em que alguém acrescentasse uma métrica.
 */
export const METRIC_ORDER: readonly AppliedScenarioMetricKey[] = [
  "availability",
  "performance",
  "quality",
  "oee",
  "goodProduction",
];

/**
 * O NOME em pt-BR de cada métrica — o mesmo vocabulário do painel de OEE.
 *
 * Spec 077 — vive no contrato, e não só no front, porque o motivo de uma causa VEDADA
 * (`allowedCausesFor().blocked[].reason`) é texto de produto escrito no pacote de domínio e exibido
 * verbatim pela tela. Sem isto o servidor mandava a chave crua ("oee, goodProduction") no meio de
 * uma frase em português, para um termo que não aparece em lugar nenhum da interface.
 */
export const METRIC_LABELS_PT: Record<AppliedScenarioMetricKey, string> = {
  availability: "Disponibilidade",
  performance: "Desempenho",
  quality: "Qualidade",
  oee: "OEE",
  goodProduction: "Produção boa",
};

/** As métricas expressas em ponto percentual — as únicas que ganham sufixo "%". */
export const PERCENT_METRIC_KEYS: ReadonlySet<AppliedScenarioMetricKey> = new Set([
  "availability",
  "performance",
  "quality",
  "oee",
]);
